import React from 'react';
import { IPresentationConfig } from '../config/clientConfig';
import TilesContainer from '../tilesNew/TilesContainer';
import DetailsContainer from '../details/DetailsContainer';
import { PageId } from '../config/constants/pageId.enum';
import { LoadingPage } from '../app/common/components/LoadingPage';

interface IHomePageProps {
    loading: boolean;
    presentationConfig: IPresentationConfig;
}

export const HomePage = ({ loading, presentationConfig }: IHomePageProps) => {
    if (loading) {
        return <LoadingPage />;
    }

    if (presentationConfig.homePage === PageId.tiles) {
        return <TilesContainer />;
    }

    return <DetailsContainer />;
};
